var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.page && _vm.page.info.total > 0
    ? _c("div", { staticClass: "pagination" }, [
        _c(
          "div",
          {
            staticClass: "pagination__element pagination__element--offset_full"
          },
          [
            _c(
              "div",
              {
                staticClass: "ug-row ug-row--apearance_spaced ug-row--space_md"
              },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "ug-cell ug-cols ug-cols--12 ug-cols--narrow-lg",
                    staticStyle: { display: "flex" }
                  },
                  [
                    _c("div", { staticClass: "pagination__action" }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "ug-row ug-row--apearance_spaced ug-row--space_md ug-row--align_center"
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "ug-cell ug-cols ug-cols--12 ug-cols--auto-md"
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "ug-row ug-row--apearance_spaced ug-row--space_md ug-row--align_center"
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "ug-cell ug-cols ug-cols--12 ug-cols--narrow-sm"
                                    },
                                    [_vm._v("Lines per page:")]
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "ug-cell ug-cols ug-cols--12 ug-cols--auto-sm"
                                    },
                                    [
                                      _c("d-control-option", {
                                        attrs: {
                                          "object-list": _vm.options,
                                          placeholder: "Limit",
                                          name: "status",
                                          id: "status"
                                        },
                                        on: { change: _vm.updateLimitHandler },
                                        model: {
                                          value: _vm.limit,
                                          callback: function($$v) {
                                            _vm.limit = $$v
                                          },
                                          expression: "limit"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ]
                              )
                            ]
                          ),
                          _c(
                            "div",
                            {
                              staticClass:
                                "ug-cell ug-cols ug-cols--12 ug-cols--narrow-sm"
                            },
                            [
                              _vm._v(
                                "Showing " +
                                  _vm._s(_vm.pageObj.from) +
                                  " to " +
                                  _vm._s(
                                    _vm.page.count < _vm.pageObj.to
                                      ? _vm.page.count
                                      : _vm.pageObj.to
                                  ) +
                                  " of " +
                                  _vm._s(_vm.page.count) +
                                  " objects"
                              )
                            ]
                          )
                        ]
                      )
                    ])
                  ]
                ),
                _c(
                  "div",
                  {
                    staticClass: "ug-cell ug-cols ug-cols--12 ug-cols--auto-lg"
                  },
                  [
                    _c(
                      "ul",
                      { staticClass: "pagination__list" },
                      [
                        _c("li", {
                          staticClass: "pagination__prev icon icon--type_prev",
                          class: { "is-disabled": !_vm.page.hasPrevious() },
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              return _vm.previous()
                            }
                          }
                        }),
                        _vm.page.hasPrevious()
                          ? [
                              _c(
                                "li",
                                {
                                  staticClass: "pagination__item",
                                  on: {
                                    click: function($event) {
                                      $event.preventDefault()
                                      return _vm.select(_vm.range.min)
                                    }
                                  }
                                },
                                [_vm._v(_vm._s(_vm.range.min))]
                              )
                            ]
                          : _vm._e(),
                        _vm.gaps.left
                          ? _c(
                              "li",
                              {
                                staticClass:
                                  "pagination__item pagination__item--inactive"
                              },
                              [_vm._v("…")]
                            )
                          : _vm._e(),
                        _vm._l(_vm.fills.left, function(page) {
                          return _c(
                            "li",
                            {
                              staticClass: "pagination__item",
                              on: {
                                click: function($event) {
                                  $event.preventDefault()
                                  return _vm.select(page)
                                }
                              }
                            },
                            [_vm._v(_vm._s(page))]
                          )
                        }),
                        _c("li", {
                          staticClass:
                            "pagination__item pagination__item--active",
                          domProps: {
                            textContent: _vm._s(_vm.page.getPageNumber())
                          }
                        }),
                        _vm._l(_vm.fills.right, function(page) {
                          return _c(
                            "li",
                            {
                              staticClass: "pagination__item",
                              on: {
                                click: function($event) {
                                  $event.preventDefault()
                                  return _vm.select(page)
                                }
                              }
                            },
                            [_vm._v(_vm._s(page))]
                          )
                        }),
                        _vm.gaps.right
                          ? _c(
                              "li",
                              {
                                staticClass:
                                  "pagination__item pagination__item--inactive"
                              },
                              [_vm._v("…")]
                            )
                          : _vm._e(),
                        _vm.page.hasNext()
                          ? [
                              _c(
                                "li",
                                {
                                  staticClass: "pagination__item",
                                  on: {
                                    click: function($event) {
                                      $event.preventDefault()
                                      return _vm.select(_vm.range.max)
                                    }
                                  }
                                },
                                [_vm._v(_vm._s(_vm.range.max))]
                              )
                            ]
                          : _vm._e(),
                        _c("li", {
                          staticClass: "pagination__next icon icon--type_next",
                          class: { "is-disabled": !_vm.page.hasNext() },
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              return _vm.next()
                            }
                          }
                        })
                      ],
                      2
                    )
                  ]
                )
              ]
            )
          ]
        )
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4205d7cc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4205d7cc","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/js/components/Modules/PaginationModule.vue
// module id = 923
// module chunks = 0